module.exports = __webpack_public_path__ + "img/Mahatma Gandhi International School.f416ca7e.jpg";